import { ContentProps } from '@wix/design-system';
import { ReactElement } from 'react';
import { useCollectionPageContent } from '../../state/CollectionPage';

export interface CollectionPageContentProps extends ContentProps {}

export type CollectionPageContentElement = ReactElement<
  CollectionPageContentProps,
  typeof CollectionPageContent
>;

export function CollectionPageContent(_props: CollectionPageContentProps) {
  return null;
}

CollectionPageContent.useCollectionPageContent = useCollectionPageContent;
CollectionPageContent.displayName = 'CollectionPageContent';
